const defaultState = {
  listLoading: false,
  pageCount: 0,
  currentPageNumber: 0,
  entities: [],
  totalResult: 0,
  error: null,
};
export const actionTypes = {
  priceQuotesFetched: 'PRICE_QUOTES_FETCHED',
  priceQuotesAppended: 'PRICE_QUOTES_APPENDED',
  addPriceQuote: 'ADD_PRICE_QUOTE',
  editPriceQuote: 'EDIT_PRICE_QUOTE',
  deletePriceQuote: 'DELETE_PRICE_QUOTE',
  editPriceQuoteFileName: 'EDIT_PRICE_QUOTE_FILE_NAME',
  createLink: 'CREATE_LINK',
  catchError: 'CATCH_ERROR'
};

const getIndex = (array, priceQuoteID) => {
  const mappedArray = array.map(item => item.priceQuoteID);
  return mappedArray.indexOf(priceQuoteID);
}

export const priceQuotesPageTableReducer = (state = defaultState, action) => {
  switch (action.type) {
    case actionTypes.priceQuotesFetched: {
      const {totalPageCount, currentPageNumber, priceQuotes, totalResultCount} = action.payload;
      return {
        ...state,
        listLoading: false,
        pageCount: totalPageCount,
        currentPageNumber: currentPageNumber,
        entities: priceQuotes,
        totalResult: totalResultCount,
        error: null
      };
    }
    case actionTypes.priceQuotesAppended: {
      const {totalPageCount, currentPageNumber, priceQuotes, totalResultCount} = action.payload;
      return {
        ...state,
        listLoading: false,
        pageCount: totalPageCount,
        currentPageNumber: currentPageNumber,
        entities: state.entities
          ? [...state.entities, ...priceQuotes]
          : [...priceQuotes],
        totalResult: totalResultCount,
        error: null
      };
    }
    case actionTypes.addPriceQuote: {
      const {
        priceQuoteID, customers, priceQuoteStatusID, priceQuoteStatusName, price, contactFirstName, contactLastName
      } = action.payload;
      const mappedCustomers = customers.map(item => {
        return {
          firstName: item.firstName,
          lastName: item.lastName,
        }
      })
      state.entities.unshift({});
      state.entities[0] = {
        priceQuoteID: priceQuoteID,
        createDate: new Date(),
        customers: mappedCustomers,
        priceQuoteStatusID: priceQuoteStatusID,
        priceQuoteStatusName: priceQuoteStatusName,
        price: price && typeof price === 'string' ? parseFloat(price) : price,
        contactFirstName: contactFirstName,
        contactLastName: contactLastName,
      };
      return {
        ...state,
        entities: [...state.entities]
      }
    }
    case actionTypes.editPriceQuote: {
      const {priceQuoteID, customers, priceQuoteStatusID, priceQuoteStatusName, price, contactFirstName, contactLastName} = action.payload;
      const index = getIndex(state.entities, priceQuoteID);
      const mappedCustomers = customers.map(item => {
        return {
          firstName: item.firstName,
          lastName: item.lastName,
        }
      })
      state.entities[index].priceQuoteID = priceQuoteID;
      state.entities[index].customers = mappedCustomers;
      state.entities[index].priceQuoteStatusID = priceQuoteStatusID;
      state.entities[index].priceQuoteStatusName = priceQuoteStatusName;
      state.entities[index].price = price;
      state.entities[index].contactFirstName = contactFirstName;
      state.entities[index].contactLastName = contactLastName;

      return {
        ...state,
        entities: [...state.entities]
      }
    }
    case actionTypes.deletePriceQuote: {
      const {priceQuoteID} = action.payload;
      const index = getIndex(state.entities, priceQuoteID);
      state.entities.splice(index, 1)
      return {
        ...state,
        entities: [...state.entities]
      }
    }
    case actionTypes.editPriceQuoteFileName: {
      const {priceQuoteID, fileName} = action.payload;
      const index = getIndex(state.entities, priceQuoteID);

      state.entities[index].fileName = fileName;
      return {
        ...state,
        entities: [...state.entities]
      }
    }
    case actionTypes.createLink: {
      const {priceQuoteID, sentTo, sentDate} = action.payload;
      const index = getIndex(state.entities, priceQuoteID);
      state.entities[index].sentTo = sentTo;
      state.entities[index].sentDate = sentDate;
      state.entities[index].priceQuoteCustomerStatusID = 2;
      state.entities[index].priceQuoteCustomerStatusName = 'ממתין לתגובה';
      return {
        ...state,
        entities: [...state.entities]
      }
    }
    case actionTypes.catchError: {
      const error = `PRICE QUOTES: ${action.payload.error}`;
      return {...state, error};
    }
    default:
      return state;
  }
};

export const actions = {
  priceQuotesFetched: (data) => ({
    type: actionTypes.priceQuotesFetched,
    payload: data
  }),
  priceQuotesAppended: (data) => ({
    type: actionTypes.priceQuotesAppended,
    payload: data
  }),
  addPriceQuote: (data) => ({
    type: actionTypes.addPriceQuote,
    payload: data
  }),
  editPriceQuote: (data) => ({
    type: actionTypes.editPriceQuote,
    payload: data
  }),
  deletePriceQuote: (data) => ({
    type: actionTypes.deletePriceQuote,
    payload: data
  }),
  editPriceQuoteFileName: (data) => ({
    type: actionTypes.editPriceQuoteFileName,
    payload: data
  }),
  createLink: (data) => ({
    type: actionTypes.createLink,
    payload: data
  }),
  catchError: (error) => ({type: actionTypes.catchError, payload: {error}}),
};
